import { ListViewer } from "views/knowledge/publication/pages/List";

export const FeedList: React.FC<{isHome?: boolean;}> = ({ isHome = false }) => {
    return <ListViewer feedListMode isHome={isHome} />;
};